import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";
interface otherUserProfileState {
  otherUserProfileDetails: {
    event: [
      {
        id: number;
        title: string;
        imagePath: string;
        imageName: string;
        description: string;
        location: string;
        eventDate: string;
        startTime: string;
        endTime: string;
        qrCode: string;
        totalSlots: number;
        contact: string;
        createdBy: string;
        createdAt: string;
        updatedAt: string;
        eventCategory: {
          id: number;
          name: string;
          createdAt: string;
          updatedAt: string;
          deleted: boolean;
        };
        deleted: boolean;
        eventCategoryName: string;
      }
    ];
    feedback: [
      {
        id: number;
        userId: string;
        rating: number;
        event: {
          id: number;
          title: string;
          description: string;
        };
        createdAt: string;
        imageName: string;
        comments: string;
        deleted: boolean;
      }
    ];
    feedbackImages: [
      {
        id: number;
        feedback: [
          {
            id: number;
            userId: string;
            rating: number;
            event: {
              id: number;
              title: string;
              description: string;
            };
            createdAt: string;
            imageName: string;
            comments: string;
            deleted: boolean;
          }
        ];
        imageName: string;
        deleted: boolean;
        featured: boolean;
      }
    ];
    hours: number;
    events: number;
    user: {
      id: number;
      userId: number;
      userName: string;
      designation: string;
      userType: string;
      image: string;
      department: string;
      userEmail: string;
      imageName: string;
    };
    testimonial: [
      {
        testimonial_id: number;
        userId: number;
        description: string;
      }
    ];
  };
}

const initialState: otherUserProfileState = {
  otherUserProfileDetails: {
    event: [
      {
        id: 0,
        title: "",
        imagePath: "",
        imageName: "",
        description: "",
        location: "",
        eventDate: "",
        startTime: "",
        endTime: "",
        qrCode: "",
        totalSlots: 0,
        contact: "",
        createdBy: "",
        createdAt: "",
        updatedAt: "",
        eventCategory: {
          id: 0,
          name: "",
          createdAt: "",
          updatedAt: "",
          deleted: false,
        },
        deleted: false,
        eventCategoryName: "",
      },
    ],
    feedback: [
      {
        id: 0,
        userId: "",
        rating: 0,
        event: {
          id: 0,
          title: "",
          description: "",
        },
        createdAt: "",
        imageName: "",
        comments: "",
        deleted: false,
      },
    ],
    feedbackImages: [
      {
        id: 0,
        feedback: [
          {
            id: 0,
            userId: "",
            rating: 0,
            event: {
              id: 0,
              title: "",
              description: "",
            },
            createdAt: "",
            imageName: "",
            comments: "",
            deleted: false,
          },
        ],
        imageName: "",
        deleted: false,
        featured: false,
      },
    ],
    hours: 0,
    events: 0,
    user: {
      id: 0,
      userId: 0,
      userName: "",
      designation: "",
      userType: "",
      image: "",
      department: "",
      userEmail: "",
      imageName: "",
    },
    testimonial: [
      {
        testimonial_id: 0,
        userId: 0,
        description: "",
      },
    ],
  },
};

const otherUserProfileDetailsSlice = createSlice({
  name: "otherUserProfileDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchOtherUserProfileDetails.fulfilled, (state, action) => {
      state.otherUserProfileDetails = action.payload;
    });
  },
});

export const fetchOtherUserProfileDetails = createAsyncThunk(
  "profile/getProfileDetails",
  async (userShortId: string = "") => {
    const response = await axiosInstance.get(
      `api/profile/getProfileDetails/${userShortId}`
    );
    return response.data;
  }
);

export default otherUserProfileDetailsSlice.reducer;
